/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

/**
 * Export `ServicePointOrderPackageModel`.
 */
@endpoint('servicePointOrderPackage')
export class ServicePointOrderPackageModel extends BaseModel {
  /**
   * Constructor.
   */
  constructor(data: Partial<ServicePointOrderPackageModel>) {
    super(data);
  }
}
